<template>
  <div class="stories-menu-container" v-if="isStoryMenuOn && isCashflowRoute && !invalidCashflow" @click="goToStoryOrTeaser">
    <div class="dashed-circle" :class="{ open: isStoryOpen }"></div>
    <div class="circle" :class="{ open: isStoryOpen }">
      <div v-if="isStoryOpen" class="emoji">🥳️</div>
      <div v-else class="number">{{ daysTillStory }}</div>
    </div>
    <div class="text-description" :class="{ open: isStoryOpen }">
      <div v-if="isStoryOpen">{{ openStoryText }}</div>
      <div v-else>{{ storyTeaserText }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import moment from 'moment';
import router from '@/router';
import Segment from '@/Segment';
import _ from 'lodash';

const EOY_STORY_START_DATE = '2023-01-08';

export default {
  name: 'NavigationHeader',
  computed: {
    ...mapGetters('featureFlags', ['isStoryMenuOn']),
    ...mapGetters('applicationState', ['cashflowTypes']),
    ...mapState('applicationState', ['cashflowState']),
    isCashflowRoute() {
      return this.$route.name === 'Home';
    },
    daysTillStory() {
      return moment(EOY_STORY_START_DATE).startOf('day').diff(moment().startOf('day'), 'days');
    },
    isStoryOpen() {
      return this.daysTillStory <= 0;
    },
    openStoryText() {
      return '<<< הסיכום השנתי שלך מוכן!';
    },
    storyTeaserText() {
      if (this.daysTillStory === 1) {
        return 'עוד יום 1 לסיכום השנתי שלך...';
      }
      return `עוד ${this.daysTillStory} ימים לסיכום השנתי שלך...`;
    },
    invalidCashflow() {
      return _.includes([this.cashflowTypes.OUT_OF_DATE, this.cashflowTypes.BUG, this.cashflowTypes.BLOCKED], this.cashflowState);
    },
  },
  methods: {
    goToStoryOrTeaser() {
      Segment.trackUserInteraction('StoryMenuClicked', { isStoryOpen: this.isStoryOpen });
      if (this.isStoryOpen) {
        router.push({ path: '/st/eoy2022' });
      } else {
        router.push({ path: '/st/eoy_countdown' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';
$spin_seconds: 10s;

.stories-menu-container {
  display: flex;
  align-items: center;
  position: relative;
  margin-right: 35px;
  .dashed-circle {
    position: absolute;
    width: 42px;
    height: 42px;
    top: -4px;
    right: -4px;
    border: 2px dotted $riseup-blue;
    border-radius: 50%;
    animation: spin $spin_seconds linear infinite;

    &.open {
      border: 2px dashed $riseup_danger_light_red;
    }
  }
  .circle {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: 34px;
    height: 34px;
    background-color: $riseup-blue;
    color: $riseup-white;
    font-size: 24px;
    &.open {
      background-color: $riseup_danger_light_red;
    }
    .number {
      position: relative;
      top: 2px;
      font-family: PauzaBold;
    }
    .emoji {
      font-size: 18px;
    }
  }
  .text-description {
    width: 90px;
    margin-right: 14px;
    font-size: 12px;
    line-height: 14px;
    &.open {
      width: 110px;
    }
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
}
</style>
